import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgActveDirectory = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-actve-directory';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.2 8.648c-2.321 2.817-4.224 5.143-4.229 5.167s1.92 1.559 4.279 3.41l4.288 3.366.214-.276c.117-.151.229-.275.248-.275s.131.124.248.275l.214.276 4.288-3.366c2.358-1.851 4.288-3.379 4.288-3.397.002-.022-8.207-10.024-8.433-10.276-.014-.016-.156.08-.316.212l-.292.24-.228-.19-.289-.24c-.052-.042-.691.716-4.28 5.074m4.03 6.71-.01 3.078-3.068-2.408c-1.688-1.324-3.065-2.422-3.06-2.439s1.385-1.702 3.068-3.746l3.06-3.717.01 3.077c.006 1.692.006 4.462 0 6.155m4.625-5.498a433 433 0 0 1 3.063 3.74c0 .016-5.127 4.051-5.961 4.692l-.197.152v-6.169c0-3.393.007-6.161.016-6.152.009.01 1.395 1.691 3.079 3.737"
    })
  }));
});
export default SvgActveDirectory;